import React, { useContext, useState } from "react";
import { Box, Card, CardContent, FormControl } from "@mui/material";
import ForgetPasswordImge from "../../../assest/ForgetPassword.svg";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { useNavigate } from "react-router-dom";
import logo from "../../../assest/images/logo.jpg";
import { postItem } from "../../../BaseUrl";
import { ForgotPassword } from "../Mutation";
import MessagePopup from "../../Utils/MessagePopup";
import { UserContext } from "../../usercontext/usercontext";

export default function ForgetPassword() {
  const navigate = useNavigate();
  const { setEmail } = useContext(UserContext);
  const [emailData, setEmailData] = useState({
    email: "",
    emailStatus: "unchecked",
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' or 'error'
  });
  const handleChange = (event) => {
    const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,6}$/g);

    let signInState = { ...emailData };
    if (event.target.name === "email") {
      if (emailRegex.test(event.target.value) === true) {
        signInState.emailStatus = "success";
      } else {
        signInState.emailStatus = "error";
      }
      signInState[event.target.name] = event.target.value;
    }
    setEmailData(signInState);
  };

  const sendMail = async () => {
    const { email } = emailData;

    const variables = {
      email: email,
    };

    try {
      const response = await postItem(ForgotPassword, variables );
      if (response?.sendOtpToEmail?.success === true) {
        setPopup({
          open: true,
          message: "Reset Password OTP send Successfully",
          severity: "success",
        });
    setEmail(email)
        setTimeout(() => {
          navigate("/otp-verify");
        }, 1000);
      } else {
        setPopup({
          open: true,
          message: response?.sendOtpToEmail?.message,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setPopup({
        open: true,
        message: error,
        severity: "error",
      });
    } finally {
    }
    setEmail(email);
    // navigate("/otp-verify");
  };
  return (
    <Box>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <Box sx={{ p: 4 }}>
        <img
          src={logo}
          alt="log img"
          style={{ height: "60px", width: "140px" }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "70vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            gap: 2,
            width: "100%",
          }}
        >
          {/* Illustration Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <img src={ForgetPasswordImge} alt="ForgetPasswordImge" />
          </Box>

          {/* Form Section */}
          <Card
            sx={{
              flex: 1,
              maxWidth: 400,
              padding: 4,
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CardContent>
              <MaterialTypography variant="h6" fontWeight="bold" gutterBottom>
                Forgot Password
              </MaterialTypography>
              <MaterialTypography
                sx={{ marginBottom: 2, color: "#989898", fontSize: "14px" }}
              >
                Enter the mail you used to create the account, a 6-digit OTP
                will be sent to the mail ID.
              </MaterialTypography>
              <FormControl fullWidth>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  sx={{ color: "black" }}
                >
                  Email ID:
                </MaterialTypography>
                <MaterialInput
                  fullWidth
                  placeholder="Email"
                  name="email"
                  variant="standard"
                  value={emailData.email}
                  onChange={handleChange}
                  error={emailData.emailStatus === "error" ? true : false}
                  success={emailData.emailStatus === "success" ? true : false}
                />
              </FormControl>
              <MaterialBox
                sx={{ display: "flex", justifyContent: "center" }}
                my={2}
              >
                <MaterialButton
                  variant="contained"
                  onClick={() => {
                    sendMail();
                  }}
                  disabled={emailData.emailStatus !== "success"}
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                >
                  Next
                </MaterialButton>
              </MaterialBox>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
